import $ from 'jquery';
import recaptcha from 'modules/recaptcha';
import Vue from 'vue';
import 'sass/cadremploi-webapp/commons.scss';
import 'smartbanner.js/dist/smartbanner'; // import d�gueu fix� dans la prochaine version https://github.com/ain/smartbanner.js/pull/108
import '@ce/ce-front-components-lib/dist/ce-front-components-lib.esm.css';
import { Header, Footer } from '@ce/ce-front-components-lib';

export default function(configuration) {
  // Initialisation du Recaptcha pour les formulaires de connexion
  recaptcha.initAsyncOnSubmit('connexion');

  const headerComponent = Vue.extend(Header);
  const header = new headerComponent({
    propsData: JSON.parse(configuration.sessionData),
    el: '#header'
  });

  const sessionDataBase64 = btoa(configuration.sessionData);
  if (!sessionStorage.getItem(sessionDataBase64)) {
    // On stocke le r�sultat de la hydration dans le session storage pour �tre r�utilis� aux prochains chargements de page.
    // Voir layout.decorator.jsp pour l'utilisation du cache
    const headerHtml = document.querySelector('#header');
    sessionStorage.setItem(sessionDataBase64, headerHtml.outerHTML);
  }
  // Ouverture de la modale de connexion pour la candidature
  $('.js-connexion-espace-perso-postuler').click(function() {
    header.openConnectionModal();
  });

  new Vue(Footer).$mount('#footer');
}
